/**
 * Email sign-up: showing "Check your email" and offering to send it again
 * (release fixes, 28 Sep 2026).
 *
 * The API answers the address trimmed and lowercased. RegisterForm used to show
 * the confirmation only when that answer equalled what was typed, so any
 * capital letter showed nothing and "Create account" could be pressed again.
 * The confirmation now follows the send itself. The API answers a repeat for
 * the same address within REGISTER_RESEND_SECONDS with the same pending
 * sign-up and no second email (AuthService.RegisterResendSeconds), so "Send it
 * again" waits that long.
 *
 * Pure, imported explicitly. Mirrors the app's register_confirmation.dart.
 */

export const REGISTER_RESEND_SECONDS = 60;

export const REGISTER_CONFIRMATION = {
    title: 'Check your email',
    sentTo: "We've sent a link to",
    nextStep: 'Open it to set your password and finish creating your account.',
    spam: 'Nothing arrived? Check your spam folder.',
    resend: 'Send it again',
    resent: 'We sent it again.',
    differentEmail: 'Use a different email',
};

const normalise = (email) => (typeof email === 'string' ? email.trim().toLowerCase() : '');

export function sameEmail(a, b) {
    const x = normalise(a);
    return x !== '' && x === normalise(b);
}

/**
 * Where the sign-up email went, or null when it did not go. `item` is the API's
 * answer (useCrudApi leaves it undefined when the request never arrived) and
 * `errors` its refusal.
 */
export function registerSentTo(item, errors, typedEmail) {
    if (!item || Object.keys(errors ?? {}).length > 0) return null;
    return normalise(item.email) || normalise(typedEmail) || null;
}

export function resendSecondsLeft(sentAtMs, nowMs) {
    if (sentAtMs == null) return REGISTER_RESEND_SECONDS;
    const left = REGISTER_RESEND_SECONDS - (nowMs - sentAtMs) / 1000;
    return Math.max(0, Math.ceil(left));
}

export function canResendRegistration(sentAtMs, nowMs) {
    return sentAtMs != null && resendSecondsLeft(sentAtMs, nowMs) === 0;
}

export function resendWaitLine(seconds) {
    return `You can send it again in ${seconds} ${seconds === 1 ? 'second' : 'seconds'}.`;
}
